export default {
  confirm: 'Potwierdź usunięcie konta',
  action: 'Usuń konto',
};
